import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../env';
import {InvitationResponse, InvitationPreview} from '../../models/invitationResponse';
import { AppLogger, AppLoggerService } from '../../core/logging';

@Injectable({
  providedIn: 'root'
})
export class InvitationService {

  private readonly log: AppLogger;

  constructor(private http: HttpClient, appLogger: AppLoggerService) {
    this.log = appLogger.createForClass(InvitationService);
  }

  getAllInvitations(): Observable<InvitationResponse[]> {
    this.log.debug('Fetch all invitations..');
    return this.http.get<InvitationResponse[]>(`${environment.apiUrl}/invites?state=PENDING`);
  }

  getInvitationById(invitationId: number): Observable<InvitationResponse> {
    this.log.debug('Fetch Invitation with id ' + invitationId);
    return this.http.get<InvitationResponse>(`${environment.apiUrl}/invites/${invitationId}`);
  }

  acceptInvitation(invitationId: number): Observable<any> {
    this.log.debug(`Accept the invitation ${invitationId}`);
    const invitation: { state: string } = {state: 'ACCEPTED'};
    return this.http.put(`${environment.apiUrl}/invites/${invitationId}`, invitation);
  }

  resendInvitation(invitationId: number): Observable<any> {
    const invitation: { state: string } = {state: 'PENDING'};
    return this.http.put(`${environment.apiUrl}/invites/${invitationId}`, invitation);
  }

  createInvite(householdId: number, inviteeEmail: string): Observable<any> {
    this.log.debug(`create new invitation for user ${inviteeEmail}`);
    const invitation ={
      email: inviteeEmail
    };
    return this.http.post<any>(`${environment.apiUrl}/households/${householdId}/invites`, invitation);
  }

  getInvitationsOfHousehold(householdId: number): Observable<InvitationResponse[]> {
    this.log.debug(`get all pending invitations of household`, {householdId});
    return this.http.get<InvitationResponse[]>(`${environment.apiUrl}/households/${householdId}/invites`);
  }

  rejectInvitation(invitationId: number): Observable<any> {
    const invitation: { state: string } = {state: 'REJECTED'};
    return this.http.put<any>(`${environment.apiUrl}/invites/${invitationId}`, invitation);
  }

  revokeInvitation(invitationId: number): Observable<any> {
    return this.http.delete<any>(`${environment.apiUrl}/invites/${invitationId}`);
  }

  getInvitationPreview(token: string): Observable<InvitationPreview> {
    this.log.debug(`Fetch invitation preview with token ${token}`);
    return this.http.get<any>(`${environment.apiUrl}/invitations/${token}/preview`);
  }

}
